module.exports = __webpack_public_path__ + "img/opinionlab-2016-salon.a22ddb5d.jpg";